import { Injectable } from '@angular/core';
import { CalculationBaseFormFactory } from '../../../base-form/form/base-form/calculation-base-form.factory';
import {
  WithholdingTaxOptions,
} from '../../../../../../../../../../../common/src/options/calculations/withholding-tax/withholding-tax.options';
import { FormFactory } from "@magieno/angular-advanced-forms";

@Injectable()
export class WithholdingTaxFormFactory extends CalculationBaseFormFactory {

  constructor(formFactory: FormFactory) {
    super(formFactory);
    this.optionsType = WithholdingTaxOptions;
  }
}
